var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBzHeating(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.44 48L63 58h-5.22L49 47.74l10-9.81-10-9.82L57.65 18h5.27l-8.48 9.87 10.33 10.06L54.44 48zM52.2 38L41.87 27.87 50.34 18h-5.27l-8.69 10.11 10.08 9.82-10.08 9.81L45.2 58h5.27l-8.6-10L52.2 38zm-12.58 0L29.29 27.87 37.77 18h-5.28L23.8 28.11l10.08 9.82-10.08 9.81L32.62 58h5.28l-8.61-10 10.33-10zM27 37.93L16.71 27.87 25.19 18h-5.27l-8.69 10.11 10.07 9.82-10.07 9.81L20 58h5.28l-8.57-10L27 37.93z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/BZ_Heating.e936854c.svg";
export { SvgBzHeating as ReactComponent };